import { useMutation, useQueryClient } from '@tanstack/react-query';

import { LereToursPricingApplyRequest } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereToursPricingHistoryQueryKeys } from './lereToursPricingHistoryQueryKeys';
import { lereToursPricingSuggestionsQueryKeys } from './lereToursPricingSuggestionsQueryKeys';

export function useApplyTccToursPricingSuggestion(options: {
  onSuccess: (
    data: Awaited<ReturnType<typeof LereService.applyToursPricingSuggestion>>,
    body: LereToursPricingApplyRequest,
  ) => void;
  onError: (error: Error) => void;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: LereToursPricingApplyRequest) => LereService.applyToursPricingSuggestion(body),
    onSuccess: (data, body) => {
      queryClient.invalidateQueries({ queryKey: lereToursPricingSuggestionsQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: lereToursPricingHistoryQueryKeys.all });
      options.onSuccess(data, body);
    },
    onError: options.onError,
  });
}
